import { createSlice } from '@reduxjs/toolkit';
import ApiListDev from '../resources/json/listOfApi-dev.json';
import ApiListLocal from '../resources/json/listOfApi-local.json';
import ApiListTest from '../resources/json/listOfApi-test.json';
import ApiListProd from '../resources/json/listOfApi-prod.json';


let initialState = {apiList: {}};

if (window.REACT_APP_ENV === 'DEV') {
   initialState = {apiList: ApiListDev};
} else if (window.REACT_APP_ENV === 'PROD') {
  initialState = {apiList: ApiListProd};
} else if (window.REACT_APP_ENV === 'TEST') {
  initialState = {apiList: ApiListTest};
}else{
  initialState = {apiList: ApiListLocal};
}


export const apiListSlice = createSlice({
  name: 'apiList',
  initialState,
  reducers: {
    setApiList: (state,env) => {
        if (window.REACT_APP_ENV === 'DEV') {
            state.apiList = ApiListDev;
        } else if (window.REACT_APP_ENV === 'TEST') {
            state.apiList = ApiListTest;
        } else if (window.REACT_APP_ENV === 'PROD') {
            state.apiList = ApiListProd;
        } else{
          state.apiList = ApiListLocal;
        }
        console.log(state.apiList);
    }
  },
})

export const { setApiList } = apiListSlice.actions;

export default apiListSlice.reducer;